// This is the class which is applied to the root container of the delta-matrix app
export const DM_ROOT_CLASS = 'ua-dm';
export const DM_ROOT_CLASS_SELECTOR = `.${DM_ROOT_CLASS}`;
